export default () => {
    let timeline = document.querySelector('.js-timeline');
    let vw = document.body.clientWidth;
    if(timeline){
        if( vw < 768 ) {
            timeline.src = timeline.dataset.mobile;
        } else {
            timeline.src = timeline.dataset.desktop;
        }
    }
    
    window.addEventListener('resize', () => {
        vw = document.body.clientWidth;
        if(timeline){
            if(vw < 768 ) {
                timeline.src = timeline.dataset.mobile;
            } else {
                timeline.src = timeline.dataset.desktop;
            }
        }
    })
}